<template>
  <div>
    <a-modal width="700px" style="vertical-align: middle" :visible="policyVisible" title="政策推送" @cancel="cancel" @ok="handleOk" okText="确认" cancelText="取消">
      <a-spin class="spin" tip="加载中" size="large" :spinning="loading" />
      <div class="push">
        <span class="enterprise">推送企业:</span>
        <a-radio-group v-model="form.sendCompany">
          <a-radio :value="1"> 全部企业 </a-radio>
          <a-radio :value="2"> 部分企业 </a-radio>
        </a-radio-group>
      </div>

      <div class="push" v-show="form.sendCompany == 2">
        <div class="hy_box">
          <div class="left">
            <div class="title">
              <span style="float: left">请选择行业类型</span>
              <span style="float: right">></span>
            </div>
            <div class="item" :class="{ active: selCat == item.name }" :key="item.name" v-for="item in industryCat" @click="selItem(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="right">
            <div class="title">
              <a-input placeholder="搜索企业名称" :disabled="selCat == ''" v-model="searchValue" @input="searchCompany(searchValue)" />
            </div>
            <div style="padding: 2px 5px" v-show="iCompany.length == 0">
              暂无数据
            </div>
            <div class="item" v-show="iCompany.length > 0">
              <label>
                <input type="checkbox" style="vertical-align: middle; margin: 0 5px" :checked="
                    form.companyIdNameZqList.length == iCompany.length &&
                    form.companyIdNameZqList.length != 0
                      ? 'checked'
                      : ''
                  " @click="checkAll" />
                <span style="vertical-align: middle">全部</span>
              </label>
            </div>
            <div class="item" :key="item.fid" v-for="item in iCompany">
              <label>
                <input type="checkbox" style="vertical-align: middle; margin: 0 5px" :checked="getState(item.id)" @click="
                    selCompany(
                      item,
                      getState(item.id) == 'checked' ? 'checked' : ''
                    )
                  " />
                <span style="vertical-align: middle">{{ item.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="push">
        <span class="enterprise">推送时间:</span>
        <a-date-picker show-time value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择推送时间" v-model="form.sendDate" :disabled-date="disabledDate" :disabled-time="disabledDateTime" @change="changeSendDate" />
      </div>

      <div class="push">
        <span class="enterprise">重复推送:</span>
        <a-select style="width: 250px" v-model="form.repeateType" placeholder="请选择时间" @change="clearTime">
          <a-select-option value="不重复"> 不重复 </a-select-option>
          <a-select-option value="每周一"> 每周一 </a-select-option>
          <a-select-option value="每周二"> 每周二 </a-select-option>
          <a-select-option value="每周三"> 每周三 </a-select-option>
          <a-select-option value="每周四"> 每周四 </a-select-option>
          <a-select-option value="每周五"> 每周五 </a-select-option>
          <a-select-option value="每周六"> 每周六 </a-select-option>
          <a-select-option value="每周日"> 每周日 </a-select-option>
          <a-select-option value="每月第一天"> 每月第一天 </a-select-option>
          <a-select-option value="每月最后一天"> 每月最后一天 </a-select-option>
          <a-select-option value="每月15号"> 每月15号 </a-select-option>
        </a-select>
        <a-time-picker :value="form.repeateDate" valueFormat="HH : mm : ss" style="margin-left: 10px" v-show="form.repeateType != '不重复'" show-time placeholder="选择重复推送时间" @change="changeRepeateDate" />
      </div>
    </a-modal>
    <a-modal v-model="tipvisible" title="" @cancel="cancel" @ok="() => (tipvisible = false)" cancelText="退出操作" okText="重新操作">
      <span>未对此条消息进行推送设置，请重新设置。</span>
    </a-modal>
  </div>
</template>
<script>
import { getDateDiff } from "@/utils";
import { getListBusinessCategory } from "@/api/policySearch";
import { getIndustryType, sendNotice } from "@/api/policyPush";
import moment from "moment";
export default {
  name: "policyPush",
  props: {
    //是否显示
    policyVisible: {
      type: Boolean,
      default: false
    },
    // id: {
    //   type: String || Number,
    //   required: true
    // },
    // jobName: {
    //   type: String || Number,
    //   required: true,
    //   default: ""
    // },
    policyMessage: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    isPolicyPublish: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        sendCompany: 1, //发送企业 1全部企业 2 部分企业
        companyIdNameZqList: [], //企业名称 如果选择全部企业可为空
        //id: "", //政策id
        //jobName: "", //政策名称
        policyMessage: [],
        repeateType: "不重复", //重复推送方式
        repeateDate: "", //重复发布时间
        sendDate: null //发送时间
      },
      industryCat: [], //产业类型
      selCat: "", //当前选中产业类型
      iCompany: [], //选中产业类型下的企业
      tipvisible: false,
      searchValue: "",
      newArr: []
    };
  },
  created() {
    //获取产业类别
    getListBusinessCategory().then(res => {
      const ires = res;
      this.industryCat = ires.data || [];
    });
  },
  mounted() {
    // this.form.id = this.id;
    // this.form.jobName = this.jobName;
  },
  methods: {
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      // return current && current < moment().endOf("day");
      // Can not select days before today
      return current < moment().subtract(1, "day");
    },

    disabledDateTime() {
      let flag =
        this.form.sendDate &&
        this.form.sendDate.split(" ")[0] == new Date().Format("yyyy-MM-dd");
      //console.log('xyw',flag,this.form.sendDate.split(' ')[0],new Date().Format("yyyy-MM-dd"))
      if (flag) {
        return {
          disabledHours: () => this.range(0, new Date().getHours()),
          disabledMinutes: () => this.range(0, new Date().getMinutes() + 5),
          disabledSeconds: () => [0, new Date().getSeconds()]
        };
      }
    },

    // 搜索公司名称
    searchCompany(value) {
      if (!value.trim()) {
        this.iCompany = this.newArr;
        return;
      }
      this.iCompany = this.newArr.filter(item => {
        if (item.name && item.name.indexOf(value) > -1) {
          return item;
        }
      });
    },
    clearTime() {
      if (this.form.repeateType == "不重复") {
        this.form.repeateDate = "";
      }
    },
    getState(id) {
      let text = "";
      //console.log("id", id);
      this.form.companyIdNameZqList.forEach(n => {
        //console.log("n", n);
        if (n.id == id) {
          text = "checked";
        }
      });
      //console.log("text", text);
      return text;
    },

    checkAll() {
      if (this.form.companyIdNameZqList.length == this.iCompany.length) {
        this.form.companyIdNameZqList = [];
      } else {
        this.iCompany.map(n => {
          this.form.companyIdNameZqList.push(n);
          this.form.companyIdNameZqList = [
            ...new Set(this.form.companyIdNameZqList)
          ];
          return n;
        });
      }
    },
    selItem(item) {
      this.selCat = item.name;
      this.loading = true;
      getIndustryType(item.name).then(res => {
        //console.log("xyw", res);
        this.iCompany = res.data || [];
        this.newArr = Object.assign(this.iCompany);
        this.form.companyIdNameZqList = [];
        this.loading = false;
      });
    },
    selCompany(item, state) {
      if (state == "checked") {
        this.form.companyIdNameZqList = this.form.companyIdNameZqList.filter(
          n => n.id != item.id
        );
      } else {
        this.form.companyIdNameZqList.push(item);
      }
    },
    cancel() {
      this.tipvisible = false;
      this.$emit("update:policyVisible", false);
      this.form.sendCompany = 1;
      this.form.repeateType = "不重复";
      this.form.sendDate = "";
    },
    handleOk() {
      this.$emit("beforeOk");
      if (this.form.sendDate == "" && this.form.repeateDate == "") {
        this.tipvisible = true;
        return;
      }
      if (
        this.form.sendCompany == 2 &&
        this.form.companyIdNameZqList.length == 0
      ) {
        this.$message.warning("请选择企业");
        return;
      }
      let nowtime = new Date().Format("yyyy-MM-dd ");
      if (
        this.form.repeateDate &&
        this.form.repeateDate.indexOf(nowtime) === -1
      ) {
        this.form.repeateDate = nowtime + this.form.repeateDate;
      }
      this.form.policyMessage = [...this.policyMessage];
      sendNotice(this.form).then(res => {
        if (res.code == 0) {
          this.$message.success("推送成功");
          this.cancel(0);
          if (this.isPolicyPublish) {
            this.$emit("refresh");
          }
        }
      });
    },
    changeSendDate(value) {
      if (value) {
        let date = new Date(value);
        let currentDate = new Date();
        if (getDateDiff(currentDate, date)) {
          let min = date.getMinutes();
          let cmin = currentDate.getMinutes();
          if (Math.abs(min - cmin) < 5) {
            date.setMinutes(min + 5);
            // date.setSeconds(30)
            this.form.sendDate = date.Format("yyyy-MM-dd hh:mm:ss");
          }
        } else {
          this.form.sendDate = value;
        }
      }
    },
    changeRepeateDate(date, dateString) {
      this.form.repeateDate = dateString;
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .ant-btn-primary {
  background: #0072f7 !important;
}
// ::v-deep .ant-btn {
//   background: #0072f7;
// }
.spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.active {
  background-color: rgba(0, 114, 247, 0.08);
}

.push {
  margin-bottom: 25px;

  ::v-deep .ant-time-picker {
    width: 200px;
  }

  .enterprise {
    margin-right: 10px;
  }

  .hy_box {
    display: flex;
    border: 1px solid #d9d9d9;
    width: 600px;
    height: 232px;

    .left {
      flex: 1;
      border-right: 1px solid #d9d9d9;
      overflow-y: auto;
      position: relative;

      .title {
        position: sticky;
        top: 0;
        width: 100%;
        height: 33px;
        line-height: 32px;
        padding: 0 10px;
        border-bottom: 1px solid #d9d9d9;
        background-color: #ebf4fe;
        overflow: hidden;
      }

      .item {
        padding: 2px 5px;
        cursor: pointer;

        &:hover {
          background-color: rgba(0, 114, 247, 0.08);
        }
      }
    }

    .right {
      flex: 1;
      //border: 1px solid #d9d9d9;
      border-left: none;
      overflow-y: auto;
      position: relative;

      .title {
        border-bottom: 1px solid #d9d9d9;
        background-color: #ebf4fe;
        overflow: hidden;
        position: sticky;

        ::v-deep .ant-input {
          background-color: rgba(0, 114, 247, 0.08);
          border: none;
        }
      }

      .item {
        padding: 2px 5px;
        cursor: pointer;

        &:hover {
          background-color: rgba(0, 114, 247, 0.08);
        }
      }
    }
  }
}
</style>